export default "__VITE_ASSET__a2320d28__"